let searchPage = 1;
let params;
let paramMap = {};

let dimensionGuideForm, dimensionGuideResults, selectMake, selectModel;

let defaultSelectOptions = {
	filter: true,
	selectAll: false,
	single: true,
	multiple: false,
	width: '100%'
};
let modelPlaceholder = {
	text: 'Choose a Make',
	value: 0
};

(function($) {

	dimensionGuideForm = jQuery('#dimension-guide-form');
	dimensionGuideResults = jQuery('#dimension-guide-results');
	selectMake = jQuery('#dimension-guide-make');
	selectModel = jQuery('#dimension-guide-model');

	getDimensionGuideURLParams();

	if (paramMap['ramp_width'] && paramMap['seated_height']) {
		dimensionGuideSearch(paramMap, { searchPage: searchPage, skipHistory: true });
	} else {
		dimensionGuideSearch({}, { searchPage: searchPage, skipHistory: searchPage == 1, skipScroll: !Object.keys(paramMap).length });
	}

	selectMake.multipleSelect({
		...defaultSelectOptions,
		onClick: function(view) {
			let models = wmkDimensionGuideData.chairs.filter(function(row) {
				return row['Make'] == view.value;
			});
			selectModel.attr('disabled', false);
			let newModelData = models.map(function(row) {
				let workingText = row['Model'];
				if (wmkDimensionGuideData.chairs.filter(function(r2) {
					return r2['Make'] == row['Make'] && r2['Model'] == row['Model'];
				}).length > 1) {
					if (row['Seat Type'].toLowerCase().includes('seat off')) {
						return {
							value: null,
							text: null
						};
					}
				}
				return {
					value: row,
					text: workingText,
					make: row['Make'],
					model: row['Model'],
					seatType: row['Seat Type']
				};
			}).filter(function(row) {
				return !!row.value;
			});
			newModelData = newModelData.map(function(row) {
				return {
					value: row.value,
					text: `${row.text}${newModelData.filter(function(r2) {
						return row.make == r2.make && row.model == r2.model;
					}).length > 1 ? ` ${row.seatType}` : ``}`
				}
			});
			selectModel.multipleSelect('refreshOptions', {
				data: [
					{
						type: 'optgroup',
						label: view.value,
						children: newModelData
					}
				]
			});
			setTimeout(function() {
				selectModel.multipleSelect('open');
			}, 300);
		}
	});
	selectModel.multipleSelect({
		...defaultSelectOptions,
		data: [modelPlaceholder],
		onClick: function(view) {
			if (view.value['Width (in.)']) {
				let width = Math.round(view.value['Width (in.)'] * 100) / 100;
				dimensionGuideForm.find('[name="ramp_width"]').val(width).trigger('change');
				dimensionGuideForm.find('[name="seated_height"]').trigger('focus');
			}
		}
	});

	dimensionGuideForm.on('change', ':input', function() {
		dimensionGuideForm.find('.dimension-guide-reset').addClass('active');
	});

	dimensionGuideForm.on('change', '[name="drive"]', function() {
		let driveIsChecked = dimensionGuideForm.find('[name="drive"]:checked').val() == 'yes';
		dimensionGuideForm.find('.dimension-guide-drive-passenger-location-wrap').toggleClass('active', !driveIsChecked);
		dimensionGuideForm.find('.dimension-guide-drive-location-wrap').toggleClass('active', driveIsChecked);
		if (!driveIsChecked) {
			dimensionGuideForm.find('#dimension-guide-seated-drive-location-seat').trigger('click');
		}
	});

	dimensionGuideResults.on('click', '.dimension-guide-pagination a', function(e) {
		e.preventDefault();
		getDimensionGuideURLParams();
		let pageMatch = jQuery(this).attr('href').match(/[\?&]searchPage=(\d+)/);
		if (pageMatch && pageMatch[1]) {
			dimensionGuideSearch(getDimensionGuideFormData(), { searchPage: pageMatch[1] });
		}
	});

	dimensionGuideForm.on('submit', function(e) {
		e.preventDefault();
		dimensionGuideSearch(getDimensionGuideFormData());
	});

})(jQuery);

function getDimensionGuideURLParams() {
	params = new URLSearchParams(window.location.search);
	paramMap = {};
	for (const [key, value] of params) {
		if (key == 'searchPage') {
			searchPage = value;
		} else {
			paramMap[key] = value;
		}
	}
}

function getDimensionGuideFormData() {
	let data = {};
	for (var item of dimensionGuideForm.serializeArray()) {
		data[item.name] = item.value;
	}
	data['make'] = selectMake.multipleSelect('getSelects');
	data['model'] = selectModel.multipleSelect('getSelects');
	return data;
}

function dimensionGuideSearch(data, options) {
	dimensionGuideForm.addClass('searching');
	dimensionGuideResults.html('Searching...');
	data['searchPage'] = options && options.searchPage ? options.searchPage : 1;
	delete data['make'];
	delete data['model'];
	if (data['ramp_width'] == '') {
		delete data['ramp_width'];
	}
	if (data['seated_height'] == '') {
		delete data['seated_height'];
	}
	if (data['drive'] == 'no') {
		delete data['drive'];
	}
	if (data['passenger_location'] == 'front') {
		delete data['passenger_location'];
	}
	if (data['drive_location'] == 'seat') {
		delete data['drive_location'];
	}
	if (!options?.skipHistory) {
		var urlstring = '?';
		var i = 0;
		for (const [key, value] of Object.entries(data)) {
			if (value == '' || (key == 'searchPage' && value == 1)) { continue; }
			if (i > 0) { urlstring += '&'; }
			urlstring += key + '=' + value;
			i++;
		}
		history.pushState({
			stateType: 'dimension-guide-search',
			data: data
		}, 'Dimension Guide', location.protocol + '//' + location.host + location.pathname + urlstring);
	}

	jQuery.ajax({
		type: 'post',
		url: wmkDimensionGuideData.ajaxurl,
		data: {
			action: 'dimension_guide_filter',
			filters: {
				...data
			}
		},
		success: function(response) {
			dimensionGuideResults.html('');
			if (response.matches?.length) {
				let showMaxProductsCount = 4;
				for (var row of response.matches) {
					let productsMarkup = '';
					let i = 0;
					for (var product of row.products) {
						productsMarkup += `<li><a href="${product.url}" title="${product.name}">${product.image}</a></li>`;
						i++;
						if (i + 1 > showMaxProductsCount) {
							break;
						}
					}
					productsMarkup += `<li class="view-more-products"><div class="wp-block-buttons"><div class="wp-block-button"><a href="${row['url']}" class="wp-element-button">View Matching Inventory &gt;</a></div></div></li>`;
					dimensionGuideResults.append(`<div class="dimension-guide-result">
						${row['matched']['image']['markup'] ? `<div class="dimension-guide-result-image">${row['matched']['image']['markup']}</div>` : ''}
						<div class="dimension-guide-result-match">
							<div class="dimension-guide-result-title">${row['matched']['make_and_model']['make']['name']} ${row['matched']['make_and_model']['model']['name']} ${row['matched']['make_and_model']['conversion-make']['name']} ${row['matched']['make_and_model']['conversion-model']['name']}</div>
							<div class="dimension-guide-result-opening-height"><strong>Opening Height:</strong> ${row['matched']['measurements']['door_opening_height']}"</div>
							<div class="dimension-guide-result-ramp-width"><strong>Ramp Width:</strong> ${row['matched']['measurements']['ramp_width']}"</div>
							<div class="dimension-guide-result-conversion-ramp"><strong>Conversion Ramp:</strong> ${wmkDimensionGuideData.guideMap['conversion_method'][row['matched']['options']['conversion_method']]} ${wmkDimensionGuideData.guideMap['fo-if'][row['matched']['options']['fo-if']]}</div>
							<div class="dimension-guide-result-conversion-entry"><strong>Conversion Entry:</strong> ${wmkDimensionGuideData.guideMap['conversion_entry'][row['matched']['options']['conversion_entry']]}</div>
							<div class="dimension-guide-result-weight-capacity"><strong>Weight Capacity:</strong> ${row['matched']['measurements']['weight_capacity']} lbs.</div>
							<div class="dimension-guide-result-removable-front-seats"><strong>Removable Front Seats:</strong> ${wmkDimensionGuideData.guideMap['removable_front_row_seats'][row['matched']['options']['removable_front_row_seats']]}</div>
						</div>
						<div class="dimension-guide-result-products">
							<div class="dimension-guide-result-products-title">Matched Inventory</div>
							<ul>${productsMarkup}</ul>
						</div>
					</div>`);
				}
			} else {
				dimensionGuideResults.html('<div class="dimension-guide-results-none">No results found.</div>');
			}
			let paginationMarkup = '';
			if (response.pagination?.markup) {
				paginationMarkup = `<div class="dimension-guide-pagination">${response.pagination.markup}</div>`;
				dimensionGuideResults.append(paginationMarkup);
			}
			let actionsMarkup = '';
			if (response.matches?.length && response.all_results_url && wmkDimensionGuideData.results_actions.show_all_matching_inventory_button_toggle) {
				actionsMarkup += `<div class="wp-block-button"><a class="wp-element-button" href="${response.all_results_url}">View All Matching Inventory &gt;</a></div>`;
			}
			if (wmkDimensionGuideData.results_actions.links) {
				for (let link of wmkDimensionGuideData.results_actions.links) {
					actionsMarkup += `<div class="wp-block-button"><a class="wp-element-button" href="${link.link.url}" target="${link.link.target}">${link.link.title} &gt;</a></div>`;
				}
			}
			if (actionsMarkup.length) {
				dimensionGuideResults.append(`<div class="dimension-guide-results-actions"><div class="wp-block-buttons">${actionsMarkup}</div></div>`);
			}
			if (!options?.skipScroll) {
				jQuery('html, body').animate({
					scrollTop: jQuery('#dimension-guide-results').offset().top - 64
				}, 250);
			}
		},
		error: function(jqXHR, textStatus, errorThrown) {
			console.error(jqXHR, textStatus, errorThrown);
		},
		complete: function() {
			dimensionGuideForm.removeClass('searching');
		}
	});

}

window.onpopstate = function(event) {
	if (event.state && event.state.stateType == 'dimension-guide-search') {
		for (const [key, value] of Object.entries(event.state.data)) {
			var el = dimensionGuideForm.find('[name="' + key + '"]');
			if (el && !el.is('input[type="radio"]')) {
				el.val(value).trigger('change');
			}
		}
		var inputRadioNames = [];
		dimensionGuideForm.find('input[type="radio"][name]').each(function() {
			inputRadioNames.push(jQuery(this).attr('name'));
		});
		inputRadioNames = [...new Set(inputRadioNames)];
		for (var key of inputRadioNames) {
			if (event.state.data[key]) {
				dimensionGuideForm.find('[name="' + key + '"][value="' + event.state.data[key] + '"]').trigger('click');
			} else {
				dimensionGuideForm.find('[name="' + key + '"][data-default="true"]').trigger('click');
			}
		}
		dimensionGuideSearch(event.state.data, { skipHistory: true });
	}
}
